import { theme } from '../lumen';

export const CLUSTER_COLORS = [
  theme.color.blue[400],
  theme.color.emerald[300],
  theme.color.emerald[500],
  theme.color.emerald[100],
  theme.color.yellow[200],
  theme.color.red[300],
  theme.color.violet[300]
];
